<template>
  <tx-msg-box ref="paperDownDialog" @close="close" class="paper-down-msg-box"
              :options="{type: 'custom', title: '试卷Word版下载', width: '500px', showCancelButton: true, showConfirmButton: true, confirmButtonText: '下载', confirmButtonClass: 'btn-primary', callback: bindDownloadAnswerSheet, callbackClose: true}">
    <table class="lay-table paper-down-table">
      <tr>
        <th width="100" class="tc bg-body">Word版本</th>
        <td width="400">
          <el-radio-group class="pl10 pr10" v-model="paperForm.docVersion" size="small">
            <el-radio :label="item.id" v-for="item in wordDownConfig.down" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr>
        <th class="tc bg-body">纸张大小</th>
        <td>
          <el-radio-group class="pl10 pr10 paper-size" v-model="paperForm.paperSize" size="small">
            <el-radio :class="(item.id == 'A4' || item.id == 'B5') ? 'icon-single' : 'icon-double'" :label="item.id" v-for="item in wordDownConfig.paperSize" :key="item.id">
              {{item.value}}
              <p><span class="iconfont" :class="paperSizeIcon[item.id]"></span></p>
            </el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr>
        <th class="tc bg-body">试卷类型</th>
        <td>
          <el-radio-group class="pl10 pr10" v-model="paperForm.paperType" size="small">
            <el-radio :label="item.id" v-for="item in wordDownConfig.paperType" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr>
        <th class="tc bg-body">验证码</th>
        <td>
          <div style="display: flex; align-content: center;">
            <el-input style="display: block;" placeholder="请输入图片验证码" size="small" class="w160 ml20" v-model="identify" @keyup.enter.native="bindNextStep"></el-input>
            <tx-identify style="display: block;" title="点我刷新" class="ml10 cur-poi" @click.native="refreshCode" :identifyCode="identifyCode" :contentHeight="32" :content-width="100"></tx-identify>
          </div>
        </td>
      </tr>
    </table>
    <div class="f13 text-color-3 tc mt15" v-if="powerText && powerText !== 'success'">
      <p>提醒：{{powerText}}</p>
      <p class="mt5"><span class="text-orange cur-poi td-ul" @click="$router.open({name: 'VIP'})">升级会员</span>享受更多下载权限</p>
    </div>
  </tx-msg-box>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/10
   * @project zujuanzaixian
   * @desc
   * todo 剩余下载次数待完善
   */
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
  import {identifyCodeMixin} from '../../mixins/identify-code'
  import {downloadMixin} from '../../mixins/zj-common'
  import {mxmjDocDownApi, paperViewDocDownApi} from '../../api/zujuan'

  export default {
    name: 'comp-paper-down-pop',
    mixins: [identifyCodeMixin, downloadMixin],
    props: {},
    data () {
      return {
        paperForm: {
          docVersion: 'docx',
          paperSize: 'A4',
          paperType: 'normal'
        },
        identify: ''
      }
    },
    computed: {
      ...mapState('pop', ['paperDownPopVisible', 'paperDownOption', 'currentDownDoc', 'paperDownParams']),
      ...mapGetters('pop', ['paperSizeIcon']),
      ...mapGetters('common', ['currentSubject']),
      ...mapGetters('zujuan', ['wordDownConfig', 'powerText'])
    },
    watch: {
      'paperDownPopVisible': {
        handler (n, o) {
          if (n) {
            this.$nextTick(() => {
              this.open()
              this.canPower('paper-down')
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations('pop', ['updatePaperDownOption', 'updatePaperDownParams', 'updatePaperDownPopVisible']),
      ...mapActions('zujuan', ['canPower']),
      bindDownloadAnswerSheet (type) {
        if (type === 'confirm') {
          if (!this.identify || this.identify != this.identifyCode) {
            this.$message.error('请输入正确的图片验证码')
            return
          }
          let queryName = this.$route.name
          let data = {}
          let fetchFn
          if (queryName === 'PaperView') {
            fetchFn = paperViewDocDownApi
            data = _.assign({}, this.paperForm, this.paperDownParams)
          } else {
            fetchFn = mxmjDocDownApi
            data = _.assign({}, this.paperForm, {docID: this.currentDownDoc})
          }
          fetchFn(data, {loading: '1', loadingText: '请求下载资源中...'}).then(res => {
            this.close()
            this.$refs.paperDownDialog.close()
            this.download(res.data.docPath)
          })
        }
      },
      open () {
        this.paperForm = _.assign({}, {docVersion: 'docx', paperSize: 'A4', paperType: 'normal'})
        this.identify = ''
        this.$refs.paperDownDialog.open()
      },
      close () {
        console.log('closeDialog')
        this.updatePaperDownPopVisible(false)
      }
    }
  }
</script>

<style lang="less">
  @import "../../styles/_mixins-wln";
  .paper-down-msg-box{
    .paper-down-table{
      td {
        padding:0.4em;
      }
      th{
        padding:0.4em;
        width: 90px;
        color: @text-color-2;
      }
      .el-radio{
        margin: 5px 10px;
        .iconfont{
          font-size: 74px;
        }
        &.icon-single{
          width: 40px;
          p{
            width: 100%;
            margin-left: -15px;
          }
        }
        &.icon-double{
          width: 90px;
          p{
            width: 100%;
            margin-left: 12px;
          }
        }
      }
      .tx-identify{
        display: inline-block;
        height: 36px;
      }
      .paper-size{
        .el-radio{
          margin: 0 25px 0 10px;
          position: relative;
          height: 90px;
          .el-radio__input, .el-radio__label{
            position: absolute;
            bottom: 5px;
            left: 0;
          }
          .el-radio__label{
            left: 10px;
            bottom: 6px;
          }
          p{
            position: absolute;
            top: -75px;
            left: -14px;
          }
          &.icon-single{
            width: 40px;
            p{
              width: 100%;
              margin-left: -15px;
            }
          }
          &.icon-double{
            width: 90px;
            p{
              width: 100%;
              margin-left: 12px;
            }
          }
        }
      }
    }
    .message-box .btns .btn {
      padding: .5em;
    }
  }
</style>
